/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ADDRESS } from "../graphql/updateAddress.query";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { filter } from "lodash";
import toast from "react-hot-toast";
import { DELETE_CART } from "../graphql/deleteCart.mutation";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IdeleteCartMethods extends IPluginMethodMap {
  deleteCart(args: any): Promise<any>;
}

export class deleteCartService implements IAgentPlugin {
  readonly methods: IdeleteCartMethods;

  constructor() {
    this.methods = {
      deleteCart: this.deleteCart.bind(this),
    };
  }

  async deleteCart(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      console.log("args12345", args);
      if (client) {
        let variables: any = {
          cartId: args,
        };
        const res = await client.mutate({
          mutation: DELETE_CART,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          toast.success("Deleted from Cart!");
          return true;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        toast.error(
          _display_message?.extensions?.display_message ??
            "Something went wrong"
        );
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
